import React, { useCallback } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { PATH } from 'constants/path';
import { setReviewGroupProviderIds } from 'utils/localstore';
import ReviewProvidersPage from 'components/AddProviderModal/components/ReviewProvidersPage';

const SelectWebsiteProvidersPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const batchUid = searchParams.get('batchUid');

    const handleExit = useCallback(() => {
        navigate(PATH.DASHBOARD);
    }, [navigate]);

    const handleConfirmed = useCallback(
        (providerIds: number[]) => {
            setReviewGroupProviderIds(providerIds);
            navigate(PATH.REVIEW_PROVIDER_PROFILE);
        },
        [navigate],
    );

    return <ReviewProvidersPage batchUid={batchUid} isWebsite onExit={handleExit} onConfirmed={handleConfirmed} />;
};

export default SelectWebsiteProvidersPage;
